import Borrower from '@/pages/Proposal/Borrower';
import Reason from '@/pages/Proposal/Reason';
import AssetValue from '@/pages/Proposal/AssetValue';
import BankingConduct from '@/pages/Proposal/BankingConduct';
import IncomeLiabilities from '@/pages/Proposal/IncomeLiabilities';
import LoanAmount from '@/pages/Proposal/LoanAmount';
import ReverseMortgage from '@/pages/Proposal/ReverseMortgage';
import BusinessCredit from '@/pages/Proposal/BusinessCredit';
import Offer from '@/pages/Proposal/offer';
import Summary from '@/pages/Proposal/Summary';
import Success from '@/pages/Proposal/Success';
import ExistBankLoan from '@/pages/Proposal/ExistBankLoan';
import UploadBankFile from '@/pages/Proposal/UploadBankFile';
import RouteType from '@/pages/Proposal/RouteType';
import MortgageCycleAction from '@/pages/Proposal/MortgageCycleAction';
import MortgageCyclesSummary from '@/pages/Proposal/MortgageCyclesSummary';
import BorrowersDetails from '@/pages/Proposal/BorrowersDetails';
import LoansComparation from '@/pages/Proposal/LoansComparation';
import ExistingMortgageQuestion from '@/pages/Proposal/ExistingMortgageQuestion';
import ReverseMortgageRouteType from '@/pages/Proposal/ReverseMortgageRouteType';
import LoanAmountReverseMortgage from '@/pages/Proposal/LoanAmountReverseMortgage';
import Pay from '@/pages/Proposal/Pay';
// import { name } from 'dayjs/locale/he';
// import { element } from 'prop-types';

const routes = {
  main: {
    name: 'דף ראשי',
    path: '/',
  },
  login: {
    name: 'התחברות',
    path: '/login',
  },
  proposals: {
    name: 'הצעות',
    path: '/proposals',
  },
  adminProposals: {
    name: 'ניהול הצעות',
    path: '/adminProposals',
  },
  clients: {
    name: 'לקוחות',
    path: '/clients',
  },
  settings: {
    name: 'ניהול מערכת',
    path: '/settings',
  },
  settingsRates: {
    name: 'ניהול ריביות',
    path: '/settings/rates',
  },
  settingsMixes: {
    name: 'ניהול תמהילים',
    path: '/settings/mixes',
  },
  settingsMortgageCycleMixes: {
    name: 'ניהול תמהילים מחזור משכנתא',
    path: '/settings/mortgageCycleMixes',
  },
  settingsReverse: {
    name: 'משכנתא הפוכה',
    path: '/settings/reverse',
  },
  settingsReverseRates: {
    name: 'ניהול ריביות משכנתא הפוכה',
    path: '/settings/reverseRates',
  },
  settingsUsers: {
    name: 'משתמשים',
    path: '/settings/users',
  },
  settingsCreateUser: {
    name: 'הוספת משתמש',
    path: '/settings/createUser',
  },
  settingsEditUser: {
    name: 'עריכת משתמש',
    path: '/settings/editUser/:id',
  },
  summary: {
    name: 'סיכום הצעה',
    path: '/:id/summary',
  },
  mortgageCycleSummary: {
    name: 'סיכום שיפור משכנתא קיימת',
    path: '/:id/mortgageCycleSummary',
  },
  customizedMix: {
    name: 'תמהיל מותאם אישית',
    path: '/customizedMix',
  },
  customizedMixSummary: {
    name: 'סיכום תמהיל מותאם',
    path: '/customizedMixSummary',
  },
  newProposal: {
    id: 'newProposal',
    name: 'הצעה חדשה',
    path: '/proposal/',
    pages: [
      {
        id: 'borrower',
        name: 'פרטי לווים',
        path: '/proposal/borrower',
        element: <Borrower />,
      },
      {
        id: 'borrowerWithId',
        name: 'פרטי לווים',
        path: '/proposal/:id/borrower',
        element: <Borrower />,
      },
      {
        id: 'reason',
        name: 'מטרת ההלוואה',
        path: '/proposal/:id/reason',
        element: <Reason />,
      },
      {
        id: 'assetValue',
        name: 'ערך הנכס',
        path: '/proposal/:id/assetValue',
        element: <AssetValue />,
      },
      {
        id: 'bankingConduct',
        name: 'הוראות בנקאיות',
        path: '/proposal/:id/bankingConduct',
        element: <BankingConduct />,
      },
      {
        id: 'incomeLiabilities',
        name: 'הוראות חוב והכנסות',
        path: '/proposal/:id/incomeLiabilities',
        element: <IncomeLiabilities />,
      },
      {
        id: 'loanAmount',
        name: 'סכום הלוואה',
        path: '/proposal/:id/loanAmount',
        element: <LoanAmount />,
      },
      {
        id: 'reverseMortgage',
        name: 'משכנתא הפוכה',
        path: '/proposal/:id/reverseMortgage',
        element: <ReverseMortgage />,
      },
      {
        id: 'businessCredit',
        name: 'אשראי עסקי',
        path: '/proposal/:id/businessCredit',
        element: <BusinessCredit />,
      },
      {
        id: 'existBankLoan',
        name: 'מילוי נתוני משכנתא נוכחית',
        path: '/proposal/existBankLoan',
        element: <ExistBankLoan />,
      },
      {
        id: 'uploadBankFile',
        name: 'העלאת נתוני משכנתא נוכחית',
        path: '/proposal/:id/uploadBankFile',
        element: <UploadBankFile />,
      },
      {
        id: 'loansComparation',
        name: 'שיפור נתוני משכנתא נוכחית',
        path: '/proposal/:id/loansComparation',
        element: <LoansComparation />,
      },
      {
        id: 'mortgageCycleAction',
        name: 'דרך פעולה לשיפור משכנתא',
        path: '/proposal/:id/mortgageCycleAction',
        element: <MortgageCycleAction />,
      },
      {
        id: 'mortgageCycleSummary',
        name: 'סיכום שיפור משכנתא קיימת',
        path: '/proposal/:id/mortgageCycleSummary',
        element: <MortgageCyclesSummary />,
      },
      {
        id: 'offer',
        name: 'פרטי הצעה',
        path: '/proposal/:id/offer',
        element: <Offer />,
      },
      {
        id: 'summary',
        name: 'סיכום הצעה',
        path: '/proposal/:id/summary',
        element: <Summary />,
      },
      {
        id: 'routeType',
        name: 'סוג מסלול',
        path: '/proposal/:id/routeType',
        element: <RouteType />,
      },
      {
        id: 'success',
        name: 'סיום',
        path: '/proposal/:id/success/:isReferral',
        element: <Success />,
      },
      {
        id: 'borrowersDetails',
        name: 'פרטי הלווים',
        path: '/proposal/:id/borrowersDetails',
        element: <BorrowersDetails />,
      },
      {
        id: 'existingMortgage',
        name: 'משכנתא קיימת',
        path: '/proposal/:id/existingMortgage',
        element: <ExistingMortgageQuestion />,
      },
      {
        id: 'reverseMortgageRouteType',
        name: 'סוג מסלול',
        path: '/proposal/:id/reverseMortgageRouteType',
        element: <ReverseMortgageRouteType />,
      },
      {
        id: 'loanAmountReverseMortgage',
        name: 'גובה הלוואה',
        path: '/proposal/:id/loanAmountReverseMortgage',
        element: <LoanAmountReverseMortgage />,
      },
      {
        id: 'pay',
        name: 'תשלום',
        path: '/proposal/:id/pay',
        element: <Pay />,
      },
    ],
  },
  lead: {
    name: 'לידים',
    path: '/lead',
  },
};

export default routes;
